import { Component } from "react";
import SchemeInfo from "./SchemeInfo";
import EditSchemeInfo from "./EditSchemeInfo";
import React from "react";

import { addSchemes, updateSchemes } from "../../../stores/actions/schemesAction";
import { connect } from "react-redux";

class DisplaySchemeInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expandedRows: {},
            selectedScheme: null,//contains the state of the scheme when edit button is clicked
            schemes: this.props.schemes || [],//stores the data of available schemes from props
        }
    }

    componentDidUpdate = (prevProps, prevState) => {
        const { addSchemesError, addSchemesSuccess, updateSchemesError, updateSchemesSuccess } = this.props;

        // Handle add schemes error
        if (prevProps.addSchemesError !== addSchemesError && addSchemesError) {
            alert(addSchemesError.message);
        }

        // Handle add schemes success  
        if (prevProps.addSchemesSuccess !== addSchemesSuccess && addSchemesSuccess) {
            alert(addSchemesSuccess.message);

            // Add the scheme to local state with Firebase-generated ID
            if (this.lastAddedScheme) {
                const newSchemeWithId = {
                    ...this.lastAddedScheme,
                    id: addSchemesSuccess.id // Firebase generated ID
                };

                this.setState(prevState => ({
                    schemes: [...prevState.schemes, newSchemeWithId]
                }));

                // Clear the stored scheme
                this.lastAddedScheme = null;
            }
        }

        // Handle update schemes error  
        if (prevProps.updateSchemesError !== updateSchemesError && updateSchemesError) {
            alert(updateSchemesError.message);
        }

        // Handle update schemes success
        if (prevProps.updateSchemesSuccess !== updateSchemesSuccess && updateSchemesSuccess) {

            alert(updateSchemesSuccess.message);

            // Store the data locally before any async operations
            const updatedSchemeData = this.lastUpdatedScheme;

            if (updatedSchemeData && updatedSchemeData.id) {

                this.setState(prevState => ({
                    schemes: prevState.schemes.map(scheme =>
                        scheme.id === updatedSchemeData.id  // Use local variable instead
                            ? updatedSchemeData
                            : scheme
                    )
                }));
            }

            // Clear the stored scheme
            this.lastUpdatedScheme = null;
        }
    }

    toggleActivities = (index) => {
        this.setState(prevState => ({//prevstate = all states available in this class currently
            expandedRows: {
                ...prevState.expandedRows,//copy existing states that are related to expandedRows only
                [index]: !prevState.expandedRows[index]//toggle this specific row
            }
        }))
    }

    hideSchemeModalAdd = () => {
        document.getElementById('modal-add-scheme').style.display = 'none';
    }

    showSchemeModalAdd = () => {
        document.getElementById('modal-add-scheme').style.display = 'block';
    }

    hideSchemeModalEdit = () => {
        document.getElementById('modal-edit-scheme').style.display = 'none';
        this.setState({ selectedScheme: null });
    }

    showSchemeModalEdit = (scheme) => {
        this.setState({ selectedScheme: scheme });
        document.getElementById('modal-edit-scheme').style.display = 'block';
    }

    handleUpdateScheme = (updatedScheme) => {

        // Store the updated scheme data for use in componentDidUpdate
        this.lastUpdatedScheme = updatedScheme;

        // Call Redux action - add safety check here too
        if (updatedScheme && updatedScheme.id) {
            this.props.updateSchemes(updatedScheme, updatedScheme.id);
        } else {
            console.log('ERROR: No ID found in updatedScheme');
        }

        this.hideSchemeModalEdit();
    }

    handleAddNewScheme = (addedScheme) => {//for new scheme addition

        this.lastAddedScheme = addedScheme;
        this.props.addSchemes(addedScheme);
        this.hideSchemeModalAdd();
    }


    render() {
        const { expandedRows } = this.state;

        return (
            <>
                <div id="modal-add-scheme" className="mymodal">
                    <div className="mymodal-content col-md-6">
                        <span className="close" onClick={this.hideSchemeModalAdd}>&times;</span>
                        <b className="uppercase">Scheme Info
                            <div className="title-border"></div>
                            <SchemeInfo onAddScheme={this.handleAddNewScheme} />
                        </b>
                    </div>
                </div>
                <div id="modal-edit-scheme" className="mymodal">
                    <div className="mymodal-content col-md-6">
                        <span className="close" onClick={this.hideSchemeModalEdit}>&times;</span>
                        <b className="uppercase">Scheme Info
                            <div className="title-border"></div>
                            {this.state.selectedScheme &&
                                <EditSchemeInfo selectedScheme={this.state.selectedScheme} onUpdateScheme={this.handleUpdateScheme} />}
                        </b>
                    </div>
                </div>
                <button className="btn btn-outline-black" onClick={this.showSchemeModalAdd.bind(this)}>
                    <i className="fas fa-plus-circle" />{' '}Scheme
                </button>
                <table className="table">
                    <thead>
                        <tr>
                            <th scope="col">No.</th>
                            <th>Code</th>
                            <th>Scheme Name</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.schemes.map((scheme, i) => {
                            const isExpanded = expandedRows[i];
                            return (
                                <React.Fragment key={i}>
                                    <tr>
                                        <th scope="row">{i + 1}</th>
                                        <td>
                                            {scheme.code}
                                        </td>
                                        <td className="text-left">
                                            {scheme.name}
                                        </td>
                                        <td>
                                            <button className="m-1 btn btn-outline-black" onClick={() => this.showSchemeModalEdit(scheme)}><i className="fas fa-edit"></i></button>
                                            <button className="m-1 btn btn-outline-black" onClick={() => this.toggleActivities(i)} >
                                                <i className={`fas ${isExpanded ? 'fa-angle-up' : 'fa-angle-down'}`}></i>
                                            </button>
                                        </td>
                                    </tr>
                                    {isExpanded && scheme.activities && (
                                        <tr>
                                            <td className="text-left border border-0 p-3" colSpan={'4'}>
                                                <strong>Aktiviti:</strong>
                                                <br />
                                                {scheme.activities.map((activity, index) => (
                                                    <div key={index}>
                                                        {index + 1}. {activity}
                                                    </div>
                                                ))}
                                            </td>
                                        </tr>
                                    )}
                                </React.Fragment>)
                        })}
                    </tbody>
                </table>
            </>
        )
    }
}

const mapStateToProps = (state) => {//Get data from redux store (via reducer)
    return {
        addSchemesSuccess: state.schemes.addSchemesSuccess,
        addSchemesError: state.schemes.addSchemesError,
        updateSchemesSuccess: state.schemes.updateSchemesSuccess,
        updateSchemesError: state.schemes.updateSchemesError,
    }
}

const mapDispatchToProps = (dispatch) => {//send data to the redux store (by dispatching actions)
    return {
        addSchemes: (schemes) => dispatch(addSchemes(schemes)),
        updateSchemes: (updatedSchemes, schemesId) => dispatch(updateSchemes(updatedSchemes, schemesId))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DisplaySchemeInfo);